var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "import-history" },
    [
      _c(
        "div",
        { staticClass: "import-history__hd" },
        [
          _c("span", { staticClass: "import-history__title" }, [
            _vm._v("查看历史导入记录"),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "import-history__des" }, [
            _vm._v("(错误数据只保存七天,七天后将自动失效)"),
          ]),
          _vm._v(" "),
          _c("el-button", {
            staticClass: "xr-icon-close-btn",
            attrs: { icon: "el-icon-close" },
            on: { click: _vm.closeClick },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticClass: "import-history__bd",
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableList, height: "250" },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "create_time", label: "导入时间", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " + _vm._s(scope.row.create_time) + "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "user_name", label: "操作人", width: "80" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "address", label: "导入结果" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          `导入总数据${scope.row.total}条，覆盖${
                            scope.row.cover
                          }条，导入成功${
                            scope.row.total - scope.row.error
                          }条，导入失败${scope.row.error}条。`
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "option", width: "150", label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.total > 0
                      ? [
                          scope.row.valid == 1
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.downloadError(
                                        scope.row.error_data_file_path
                                      )
                                    },
                                  },
                                },
                                [_vm._v("下载错误数据")]
                              )
                            : scope.row.valid == 0
                            ? _c("span", { staticClass: "invalid-tips" }, [
                                _vm._v("已失效"),
                              ])
                            : _vm._e(),
                        ]
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "import-history__ft" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.closeClick } },
            [_vm._v("关闭")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }